module.exports = __webpack_public_path__ + "static/developer-step3.046b7d31.png";